/* eslint-disable */
var i18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/adextensions');
var aspectRatios = {
  ratio12x10: {
    text: i18n.getString('AdExtensions_Image_12x10'),
    ratio: 1.2 / 1,
    thumbnailWidth: 120,
    thumbnailHeight: 100,
    minWidth: 300,
    minHeight: 250,
    maxSize: [1200, 1000],
    assetType: 32
  },
  ratio4x3: {
    text: i18n.getString('AdExtensions_Image_4x3'),
    ratio: 4 / 3,
    thumbnailWidth: 133,
    thumbnailHeight: 100,
    minWidth: 100,
    minHeight: 75,
    maxSize: [1333, 1000],
    assetType: 16
  },
  ratio3x2: {
    text: i18n.getString('AdExtensions_Image_3x2'),
    ratio: 1.5 / 1,
    thumbnailWidth: 150,
    thumbnailHeight: 100,
    minWidth: 300,
    minHeight: 200,
    maxSize: [1500, 1000],
    assetType: 8
  },
  ratio16x9: {
    text: i18n.getString('AdExtensions_Image_16x9'),
    ratio: 16 / 9,
    thumbnailWidth: 178,
    thumbnailHeight: 100,
    minWidth: 640,
    minHeight: 360,
    maxSize: [1778, 1000],
    assetType: 4
  }
};
var aspectRatiosMeta = {
  assetTypeMap: {
    4: 'ratio16x9',
    8: 'ratio3x2',
    16: 'ratio4x3',
    32: 'ratio12x10'
  },
  imageEnumToType: {
    4: 'Image16x9',
    8: 'Image15x10',
    16: 'Image4x3',
    32: 'Image12x10'
  },
  imageTypeToEnum: {
    'Image16x9': 4,
    'Image15x10': 8,
    'Image4x3': 16,
    'Image12x10': 32
  },
  thumbnailWidth: function (ratio) {
    return aspectRatios[ratio].thumbnailWidth;
  },
  thumbnailHeight: function (ratio) {
    return aspectRatios[ratio].thumbnailHeight;
  },
  minWidth: function (ratio) {
    return aspectRatios[ratio].minWidth;
  },
  minHeight: function (ratio) {
    return aspectRatios[ratio].minHeight;
  },
  maxSize: function (ratio) {
    return aspectRatios[ratio].maxSize;
  },
  ratio: function (ratio) {
    return aspectRatios[ratio].ratio;
  },
  text: function (ratio) {
    return aspectRatios[ratio].text;
  },
  assetType: function (ratio) {
    return aspectRatios[ratio].assetType;
  }
};
export default aspectRatiosMeta;

